import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import Claims from './Claims';

// Satisfaction Claims — admin queue for standard-booking satisfaction-guarantee claims.
// NOT gated by largeProjectsEnabled (unlike the Big Projects Disputes route). Admin auth only.
function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  if (!isAdminAuthenticated) {
    return { redirect: '/login' };
  }
  return {
    title: 'Satisfaction Claims | Admin',
    component: (
      <AdminLayout>
        <Claims />
      </AdminLayout>
    ),
  };
}

export default action;
